class Tables {
  constructor(cat, isDefault, name) {
    this.cat = cat;
    this.isDefault = isDefault;
    this.isDefaultBool = isDefault;
    this.isDefaultTable = isDefault ? "✔️" : "";
    this.name = name;
  }

  static fromJson({ cat, def, tabla }) {
    return new Tables(cat, def, tabla);
  }
}

export default Tables;
